import { render, staticRenderFns } from "./recommendedCategories.vue?vue&type=template&id=692bc982&scoped=true&"
import script from "./recommendedCategories.vue?vue&type=script&lang=js&"
export * from "./recommendedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692bc982",
  null
  
)

/* custom blocks */
import block0 from "./recommendedCategories.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports